import React from 'react';

import StaticPageLayout from './StaticPageLayout';

const TermsOfService = () => (
  <StaticPageLayout
    eyebrow='Legal'
    title='Terms of Service'
    intro='These terms govern your use of Evento. Please read them carefully. By accessing or using the platform, you agree to be bound by them.'
    updatedAt='1 July 2026'
    sections={[
      {
        heading: 'Acceptance of terms',
        paragraphs: [
          'By creating an account or using Evento, you confirm that you can form a binding contract and agree to these terms and our Privacy Policy. If you do not agree, please do not use the service.',
        ],
      },
      {
        heading: 'Accounts',
        bullets: [
          'You are responsible for the accuracy of the information you provide and for keeping your login credentials secure',
          'Professionals may be required to complete verification before their listings are approved',
          'You are responsible for all activity that happens under your account',
        ],
      },
      {
        heading: 'Bookings & payments',
        paragraphs: [
          'Evento is a platform that connects clients with independent professionals. Agreements for services are made directly between the client and the professional.',
        ],
        bullets: [
          'Prices, packages and availability are set by the professionals',
          'Payments may be processed through third-party providers subject to their terms',
          'Cancellations, refunds and rescheduling are subject to the professional’s stated policy',
        ],
      },
      {
        heading: 'Professional obligations',
        bullets: [
          'Provide accurate listings and honour confirmed bookings',
          'Deliver services professionally and comply with applicable laws',
          'Maintain valid verification information where required',
        ],
      },
      {
        heading: 'Prohibited conduct',
        bullets: [
          'Posting false, misleading or unlawful content',
          'Attempting to circumvent the platform to avoid fees or safety measures',
          'Harassing other users or infringing their rights',
          'Interfering with the security or operation of the service',
        ],
      },
      {
        heading: 'Content & reviews',
        paragraphs: [
          'You retain ownership of content you submit but grant Evento a licence to display it in connection with the service. Reviews must reflect genuine experiences and must not be abusive or misleading.',
        ],
      },
      {
        heading: 'Disclaimers & liability',
        paragraphs: [
          'Evento is provided “as is”. We do not guarantee the quality of services provided by professionals and are not a party to the agreement between clients and professionals. To the extent permitted by law, Evento is not liable for indirect or consequential losses arising from your use of the platform.',
        ],
      },
      {
        heading: 'Termination',
        paragraphs: [
          'We may suspend or terminate accounts that violate these terms or pose a risk to the community. You may stop using the service and request account deletion at any time.',
        ],
      },
      {
        heading: 'Changes & governing law',
        paragraphs: [
          'We may update these terms from time to time; continued use after changes means you accept the updated terms. These terms are governed by the laws of Sri Lanka.',
        ],
      },
      {
        heading: 'Contact us',
        paragraphs: [
          'Questions about these terms? Email us at legal@evento.lk.',
        ],
      },
    ]}
  />
);

export default TermsOfService;
